import {
  DialogDescription,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogClose,
  DialogTitle,
  Button,
  Dialog,
} from '@ui/components';
import { useTranslation } from 'react-i18next';
import { PropsWithChildren, FC } from 'react';

import { useParkingSpotStopDialog } from './use-parking-spot-stop-dialog';

interface ParkingStopDialogProps extends PropsWithChildren {
  isOpen: boolean;
  parkingSpotId?: string;
  onClose: ({ handleSubmit }: { handleSubmit: boolean }) => void;
}

export const ParkingStopDialog: FC<ParkingStopDialogProps> = ({
  parkingSpotId,
  onClose,
  isOpen,
}) => {
  const { t } = useTranslation();
  const { stopParking, isStopParkingPending } = useParkingSpotStopDialog({
    onSuccess: () => {
      onClose({ handleSubmit: true });
    },
  });

  return (
    <Dialog onOpenChange={() => onClose({ handleSubmit: false })} open={isOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('PARKING_SPOTS.STOP_DIALOG_TITLE')}</DialogTitle>
        </DialogHeader>
        <DialogDescription>{t('PARKING_SPOTS.STOP_DIALOG_DESCRIPTION')}</DialogDescription>
        <DialogFooter className="flex justify-between gap-3">
          <DialogClose asChild>
            <Button variant="tertiary" wide>
              {t('PARKING_SPOTS.STOP_DIALOG_CANCEL')}
            </Button>
          </DialogClose>
          <Button
            onClick={() => parkingSpotId && stopParking(parkingSpotId)}
            isLoading={isStopParkingPending}
            wide
          >
            {t('PARKING_SPOTS.STOP_DIALOG_STOP_BUTTON')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
